import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = () => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, 'light');
  document.body.classList.remove('dark');
  document.documentElement.style.setProperty('color-scheme', 'light');
};
